<template>
  <div>
    <ContentsHeader>
      <template v-slot:title01>{{jobName}}</template>
      <template v-slot:explain01>
        個人や企業のお客様に対して最適な保険商品を提案し、保険加入に伴う一連の手続きのサポート業務を担当するのが保険の営業職です。保険会社に所属し自社商品を提案するか、複数の提携会社の商品から顧客に最適な商品をレコメンドする相談窓口の仕事があります。複雑で比較しにくいと言われる保険商品について自社他社製品を問わず長短を把握し、顧客の要望に対して納得感のあるプランを提案することが求められます。
        <br />ときにはFPのように顧客の資産計画にも踏み込んだパートナーとして信頼を得るこの業界の営業職にはどのような特徴が見られるのでしょうか。
      </template>
      <template v-slot:yarigai01><span class="ddin">提案した商品の保険金で顧客が支えられた</span><span class="ddin">(千葉県 59歳 男性)</span></template>
      <template v-slot:yarigai02><span class="ddin">商品と提案を通じ、お客様に安心感を与えられる</span><span class="ddin">(千葉県 46歳 男性)</span></template>
      <template v-slot:yarigai03><span class="ddin">お客様の役に立つ情報提供をして、喜んでもらえる</span><span class="ddin">(山形県 34歳 女性)</span></template>
      <template v-slot:img-headbg><img src="../assets/img/insurance/headbg.svg" :alt="jobName" class="img"></template>
      <template v-slot:img-headp><img src="../assets/img/insurance/person.svg" :alt="jobName" class="imgp -insurance"></template>
    </ContentsHeader>

    <div class="contents-block">

      <section class="job-section">
        <div class="jsinner">
          <div class="block-two -aistretch -jcsb -bptablet">
            <div class="block -b48p -p0">
              <BalanceChartSection :explain="bcExplain" :radarData="radarData"></BalanceChartSection>
            </div>
            <div class="block -b48p -p0">
              <JobChangeRateSection
                :explain="jcExplain"
                :doughnutData="doughnutData"
                :doughnutDataFake="doughnutData"
              ></JobChangeRateSection>
            </div><!-- .block -->
          </div><!-- .block-two -->
        </div><!-- .jsinner -->
      </section>

      <PersonalCharaSection :sevenData="sevenData" :secTtl="'保険業界'" >
        <template v-slot:feature>自信と慎重さを<br>併せもったパートナー</template>
        <template v-slot:imgpup><img src="../assets/img/insurance/person.svg" alt="保険業界のセールスパーソン特徴" class="imgcvperson -insurance"></template>
      </PersonalCharaSection>
    
      <div class="lb-area">
        <div class="lbinner block-two -bptablet">
          <div class="block">
            <CareerTypeSection :graphData="graphData" :explain="ctExplain" :jobName="'保険'"></CareerTypeSection>
          </div><!-- .block -->
          <div class=" block">
            <SalesTypeSection :graph2Data="graph2Data" :explain="stExplain" :jobName="'保険'"></SalesTypeSection>
          </div><!-- .block -->
        </div><!-- .block-two -->
      </div><!-- .lb-area -->

      <ResultSection :job="'insurance'">
        <template v-slot:jobname>保険業界の営業</template>
        <template v-slot:title01>人を思いやるサポーター</template>
        <template v-slot:explain01>
            人のためになる仕事をしたいという意識がとても強い傾向にあり、人の気持ちを汲み取ることにも長けています。
            <br />保険提案では、顧客の心配事や潜在的な不安を引き出してあげることより、最適なプランを検討していきます。その上で、顧客に寄り添い共感しながら、一緒に悩むことができる能力が必要であると考えられます。
        </template>
        <template v-slot:title02>「万が一の備え」に演出はいらない</template>
        <template v-slot:explain02>
          万が一の時に顧客の支えとなる保険では、魅力的な提案よりも安心感のある提案が求められます。そのため、提案内容のプレゼンやパフォーマンスといった”伝え方”に頼らず、顧客からの信頼や提案内容への納得感を得ることで契約に繋げようという意識の高い人が多いことが読み取れます。
        </template>
        <template v-slot:imgperson><img src="../assets/img/insurance/person.svg" alt="保険業界の営業" class="rsimg"></template>
      </ResultSection>

      <section class="other-section">
        <h2 class="osttl">その他の業界ごとの詳細をのぞく</h2>
        <div class="osinner">
          <DetailsList :job="'insurance'"></DetailsList>
        </div><!-- .osinner -->
      </section>

    </div>

  </div><!-- .contents-block -->
</template>

<script>
import ContentsHeader from "../components/ContentsHeader.vue";
import ResultSection from "../components/ResultSection.vue";

import BalanceChartSection from "../components/BalanceChartSection.vue";
import JobChangeRateSection from "../components/JobChangeRateSection.vue";
import PersonalCharaSection from "../components/PersonalCharaSection.vue";
import CareerTypeSection from "../components/CareerTypeSection.vue";
import SalesTypeSection from "../components/SalesTypeSection.vue";
import DetailsList from "../components/DetailsList.vue";

export default {
  data() {
    return {
      pageTitle: "保険業界の営業をのぞく",
      pageURL: "insurance",
      pageDescription: "SALES 「できる営業像」は業界ごとに違う？「SALES SALES SCOPEでは不動産、保険、ITなど人気10業界の営業職に人物特性と成績に関する調査を実施。個人や企業のお客様に対して最適な保険商品を提案し、保険加入に伴う一連の手続きのサポート業務を担当するのが保険の営業職です。ときにはFPのように顧客の資産計画にも踏み込んだパートナーとして信頼を得るこの業界の営業職にはどのような特徴が見られるのでしょうか。",

      jobName: "保険の営業",
      bcExplain: "献身性に特に長け、社交性は低め",
      jcExplain: "転職回数はかなり多い",
      ctExplain: "公私両立を図るワークライフバランスタイプがやや多い",
      stExplain:
        "顧客と親密な関係を築こうとするタイプが多く、演出した提案をおこなおうとするタイプは少ない",
      radarData: [5.55, 3.69, 9.77, 7.55, 4.35],
      doughnutData: [11, 33, 19, 15, 22],
      sevenData: [3, 3, 4, 6, 3, 6, 4],
      graphData: [
        { num: 1, val: 11 },
        { num: 2, val: 15 },
        { num: 3, val: 4 },
        { num: 4, val: 15 },
        { num: 5, val: 3 },
        { num: 6, val: 15 },
        { num: 7, val: 15 },
        { num: 8, val: 22 },
      ],
      graph2Data: [
        { num: 1, val: 3.7037037037037 },
        { num: 2, val: 33.3333333333333 },
        { num: 3, val: 3.7037037037037 },
        { num: 4, val: 29.6296296296296 },
        { num: 5, val: 29.6296296296296 },
      ],
    };
  },
  components: {
    BalanceChartSection,
    JobChangeRateSection,
    PersonalCharaSection,
    CareerTypeSection,
    SalesTypeSection,
    DetailsList,
    ContentsHeader,
    ResultSection
  },
  metaInfo: {
    title: "保険の営業をのぞく | 営業職の特徴を人物特性からのぞいてみた",
    titleTemplate: "%s | SALES SCOPE",
    htmlAttrs: {
      lang: "jp",
    },
  },
  mounted: function(){
    // document.title = title;
    document.querySelector("meta[name='description']").setAttribute('content', this.pageDescription);
    document.querySelector("meta[property='og:title']").setAttribute('content', this.pageTitle + " | 営業職の特徴を人物特性からのぞいてみた | SALES SCOPE");
    document.querySelector("meta[property='og:description']").setAttribute('content', this.pageDescription);
    document.querySelector("meta[property='og:url']").setAttribute('content', 'https://sales-score.jp/scope/' + this.pageURL);
  }

};
</script>